import { coerceNumberProperty } from '@angular/cdk/coercion';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BaseService } from '../../services/base.service';
import { CommonService } from '../../services/common.service';

@Component({
  selector: 'ara-file-viewer',
  templateUrl: './file-viewer.component.html',
  styleUrls: ['./file-viewer.component.css']
})
export class FileViewerComponent implements OnInit {
  descriptionListId: number = 0;
  descriptionData: any = [];

  constructor(private route: ActivatedRoute, private commonService: CommonService, private baseService: BaseService,
    private translate: TranslateService) { }

  ngOnInit() {
    this.baseService.showRootLoader = true;
    this.route.params.subscribe(params => {
      this.descriptionListId = coerceNumberProperty(params['descriptionListId']);
    });
    if (this.descriptionListId) {
      const apiRequest = {
        Model: {
          DescriptionListId: this.descriptionListId
        }
      }
      this.commonService.getDescriptionListData(apiRequest, this.callbackMethodForGetDescriptionListData.bind(this));
    }
    this.baseService.translatorListener.subscribe((data) => {
      this.translate.use(data);
    });
  }
  callbackMethodForGetDescriptionListData(response) {
    if (response.Success) {
      this.descriptionData = response.Result;
    }
    this.baseService.showRootLoader = false;
  }
}
